export default __webpack_public_path__ + "static/media/Facebook.17150f8a.png";